import { BaseEntityLineChart } from '../../../components/Charts';
import { useMergedProvincesChart } from '../hooks';
import { useAppSelector } from '../../../store/hooks';

interface ProvincesMergedChartProps {
	height?: number;
}

export function ProvincesMergedChart({ height = 400 }: ProvincesMergedChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useMergedProvincesChart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		}
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Tỉnh thành (Sau sáp nhập)"
			downloadFilename="bieu-do-tinh-thanh-sap-nhap"
			entityLabel="Chọn tỉnh thành"
			entityPlaceholder="Tất cả tỉnh thành"
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
